import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './viewCursors.css';
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { IntervalTimer, TimeoutTimer } from '../../../../base/common/async.js';
import { ViewPart } from '../../view/viewPart.js';
import { ViewCursor } from './viewCursor.js';
import { TextEditorCursorStyle } from '../../../common/config/editorOptions.js';
import { editorCursorBackground, editorCursorForeground } from '../../../common/view/editorColorRegistry.js';
import { registerThemingParticipant } from '../../../../platform/theme/common/themeService.js';
export var ViewCursors = /*#__PURE__*/function (_ViewPart) {
  _inherits(ViewCursors, _ViewPart);

  var _super = _createSuper(ViewCursors);

  function ViewCursors(context) {
    var _this;

    _classCallCheck(this, ViewCursors);

    _this = _super.call(this, context);
    var options = _this._context.configuration.options;
    _this._readOnly = options.get(72
    /* readOnly */
    );
    _this._cursorBlinking = options.get(17
    /* cursorBlinking */
    );
    _this._cursorStyle = options.get(19
    /* cursorStyle */
    );
    _this._cursorSmoothCaretAnimation = options.get(18
    /* cursorSmoothCaretAnimation */
    );
    _this._selectionIsEmpty = true;
    _this._isVisible = false;
    _this._primaryCursor = new ViewCursor(_this._context);
    _this._secondaryCursors = [];
    _this._renderData = [];
    _this._domNode = createFastDomNode(document.createElement('div'));

    _this._domNode.setAttribute('role', 'presentation');

    _this._domNode.setAttribute('aria-hidden', 'true');

    _this._updateDomClassName();

    _this._domNode.appendChild(_this._primaryCursor.getDomNode());

    _this._startCursorBlinkAnimation = new TimeoutTimer();
    _this._cursorFlatBlinkInterval = new IntervalTimer();
    _this._blinkingEnabled = false;
    _this._editorHasFocus = false;

    _this._updateBlinking();

    return _this;
  }

  _createClass(ViewCursors, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ViewCursors.prototype), "dispose", this).call(this);

      this._startCursorBlinkAnimation.dispose();

      this._cursorFlatBlinkInterval.dispose();
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      this._readOnly = options.get(72
      /* readOnly */
      );
      this._cursorBlinking = options.get(17
      /* cursorBlinking */
      );
      this._cursorStyle = options.get(19
      /* cursorStyle */
      );
      this._cursorSmoothCaretAnimation = options.get(18
      /* cursorSmoothCaretAnimation */
      );

      this._updateBlinking();

      this._updateDomClassName();

      this._primaryCursor.onConfigurationChanged(e);

      for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
        this._secondaryCursors[i].onConfigurationChanged(e);
      }

      return true;
    }
  }, {
    key: "_onCursorPositionChanged",
    value: function _onCursorPositionChanged(position, secondaryPositions) {
      this._primaryCursor.onCursorPositionChanged(position);

      this._updateBlinking();

      if (this._secondaryCursors.length < secondaryPositions.length) {
        // Create new cursors
        var addCnt = secondaryPositions.length - this._secondaryCursors.length;

        for (var i = 0; i < addCnt; i++) {
          var newCursor = new ViewCursor(this._context);

          this._domNode.domNode.insertBefore(newCursor.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling);

          this._secondaryCursors.push(newCursor);
        }
      } else if (this._secondaryCursors.length > secondaryPositions.length) {
        // Remove some cursors
        var removeCnt = this._secondaryCursors.length - secondaryPositions.length;

        for (var _i = 0; _i < removeCnt; _i++) {
          this._domNode.removeChild(this._secondaryCursors[0].getDomNode());

          this._secondaryCursors.splice(0, 1);
        }
      }

      for (var _i2 = 0; _i2 < secondaryPositions.length; _i2++) {
        this._secondaryCursors[_i2].onCursorPositionChanged(secondaryPositions[_i2]);
      }
    }
  }, {
    key: "onCursorStateChanged",
    value: function onCursorStateChanged(e) {
      var positions = [];

      for (var i = 0, len = e.selections.length; i < len; i++) {
        positions[i] = e.selections[i].getPosition();
      }

      this._onCursorPositionChanged(positions[0], positions.slice(1));

      var selectionIsEmpty = e.selections[0].isEmpty();

      if (this._selectionIsEmpty !== selectionIsEmpty) {
        this._selectionIsEmpty = selectionIsEmpty;

        this._updateDomClassName();
      }

      return true;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      // true for inline decorations that can end up relayouting text
      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onFocusChanged",
    value: function onFocusChanged(e) {
      this._editorHasFocus = e.isFocused;

      this._updateBlinking();

      return false;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return true;
    }
  }, {
    key: "onTokensChanged",
    value: function onTokensChanged(e) {
      var shouldRender = function shouldRender(position) {
        for (var i = 0, len = e.ranges.length; i < len; i++) {
          if (e.ranges[i].fromLineNumber <= position.lineNumber && position.lineNumber <= e.ranges[i].toLineNumber) {
            return true;
          }
        }

        return false;
      };

      if (shouldRender(this._primaryCursor.getPosition())) {
        return true;
      }

      var _iterator = _createForOfIteratorHelper(this._secondaryCursors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var secondaryCursor = _step.value;

          if (shouldRender(secondaryCursor.getPosition())) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    } // --- end event handlers
    // ---- blinking logic

  }, {
    key: "_getCursorBlinking",
    value: function _getCursorBlinking() {
      if (!this._editorHasFocus) {
        return 0
        /* Hidden */
        ;
      }

      if (this._readOnly) {
        return 5
        /* Solid */
        ;
      }

      return this._cursorBlinking;
    }
  }, {
    key: "_updateBlinking",
    value: function _updateBlinking() {
      var _this2 = this;

      this._startCursorBlinkAnimation.cancel();

      this._cursorFlatBlinkInterval.cancel();

      var blinkingStyle = this._getCursorBlinking(); // hidden and solid are special as they involve no animations


      var isHidden = blinkingStyle === 0
      /* Hidden */
      ;
      var isSolid = blinkingStyle === 5
      /* Solid */
      ;

      if (isHidden) {
        this._hide();
      } else {
        this._show();
      }

      this._blinkingEnabled = false;

      this._updateDomClassName();

      if (!isHidden && !isSolid) {
        if (blinkingStyle === 1
        /* Blink */
        ) {
          // flat blinking is handled by JavaScript to save battery life due to Chromium step timing issue https://bugs.chromium.org/p/chromium/issues/detail?id=361587
          this._cursorFlatBlinkInterval.cancelAndSet(function () {
            if (_this2._isVisible) {
              _this2._hide();
            } else {
              _this2._show();
            }
          }, ViewCursors.BLINK_INTERVAL);
        } else {
          this._startCursorBlinkAnimation.setIfNotSet(function () {
            _this2._blinkingEnabled = true;

            _this2._updateDomClassName();
          }, ViewCursors.BLINK_INTERVAL);
        }
      }
    } // --- end blinking logic

  }, {
    key: "_updateDomClassName",
    value: function _updateDomClassName() {
      this._domNode.setClassName(this._getClassName());
    }
  }, {
    key: "_getClassName",
    value: function _getClassName() {
      var result = 'cursors-layer';

      if (!this._selectionIsEmpty) {
        result += ' has-selection';
      }

      switch (this._cursorStyle) {
        case TextEditorCursorStyle.Line:
          result += ' cursor-line-style';
          break;

        case TextEditorCursorStyle.Block:
          result += ' cursor-block-style';
          break;

        case TextEditorCursorStyle.Underline:
          result += ' cursor-underline-style';
          break;

        case TextEditorCursorStyle.LineThin:
          result += ' cursor-line-thin-style';
          break;

        case TextEditorCursorStyle.BlockOutline:
          result += ' cursor-block-outline-style';
          break;

        case TextEditorCursorStyle.UnderlineThin:
          result += ' cursor-underline-thin-style';
          break;

        default:
          result += ' cursor-line-style';
      }

      if (this._blinkingEnabled) {
        switch (this._getCursorBlinking()) {
          case 1
          /* Blink */
          :
            result += ' cursor-blink';
            break;

          case 2
          /* Smooth */
          :
            result += ' cursor-smooth';
            break;

          case 3
          /* Phase */
          :
            result += ' cursor-phase';
            break;

          case 4
          /* Expand */
          :
            result += ' cursor-expand';
            break;

          case 5
          /* Solid */
          :
            result += ' cursor-solid';
            break;

          default:
            result += ' cursor-solid';
        }
      } else {
        result += ' cursor-solid';
      }

      if (this._cursorSmoothCaretAnimation) {
        result += ' cursor-smooth-caret-animation';
      }

      return result;
    }
  }, {
    key: "_show",
    value: function _show() {
      this._primaryCursor.show();

      for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
        this._secondaryCursors[i].show();
      }

      this._isVisible = true;
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this._primaryCursor.hide();

      for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
        this._secondaryCursors[i].hide();
      }

      this._isVisible = false;
    } // ---- IViewPart implementation

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      this._primaryCursor.prepareRender(ctx);

      for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
        this._secondaryCursors[i].prepareRender(ctx);
      }
    }
  }, {
    key: "render",
    value: function render(ctx) {
      var renderData = [],
          renderDataLen = 0;

      var primaryRenderData = this._primaryCursor.render(ctx);

      if (primaryRenderData) {
        renderData[renderDataLen++] = primaryRenderData;
      }

      for (var i = 0, len = this._secondaryCursors.length; i < len; i++) {
        var secondaryRenderData = this._secondaryCursors[i].render(ctx);

        if (secondaryRenderData) {
          renderData[renderDataLen++] = secondaryRenderData;
        }
      }

      this._renderData = renderData;
    }
  }, {
    key: "getLastRenderData",
    value: function getLastRenderData() {
      return this._renderData;
    }
  }]);

  return ViewCursors;
}(ViewPart);
ViewCursors.BLINK_INTERVAL = 500;
registerThemingParticipant(function (theme, collector) {
  var caret = theme.getColor(editorCursorForeground);

  if (caret) {
    var caretBackground = theme.getColor(editorCursorBackground);

    if (!caretBackground) {
      caretBackground = caret.opposite();
    }

    collector.addRule(".monaco-editor .cursors-layer .cursor { background-color: ".concat(caret, "; border-color: ").concat(caret, "; color: ").concat(caretBackground, "; }"));

    if (theme.type === 'hc') {
      collector.addRule(".monaco-editor .cursors-layer.has-selection .cursor { border-left: 1px solid ".concat(caretBackground, "; border-right: 1px solid ").concat(caretBackground, "; }"));
    }
  }
});